import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '../models/api.model';
import { API_URL } from '../config/api.config';
import { RolesDto } from '../models/roles.model';

@Injectable({ providedIn: 'root' })
export class RolesService {
  private readonly http = inject(HttpClient);
  private readonly resourceUrl = `${API_URL}/roles`;

  getAll(): Observable<RolesDto[]> {
    return this.http
      .get<ApiResponse<RolesDto[]>>(this.resourceUrl)
      .pipe(map((response) => response.data ?? []));
  }
}
